import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import NavOutlet from 'components/NavOutlet';
import {
  hideTransactionDetailModal,
  setTransactionDetail,
} from 'actions/reports/transactions';
import {
  setReceiptInvoices,
  hideReceiptInvoice,
} from 'actions/reports/invoices';
import NavMokaLogo from './NavMokaLogo';
import NavLoggedIn from './NavLoggedIn';
import NavNotLoggedIn from './NavNotLoggedIn';
import styles from './style.css';

class Nav extends React.Component {
  shouldComponentUpdate(nextProps) {
    if (this.props.loggedIn !== nextProps.loggedIn) {
      return true;
    }
    if (this.props.location.pathname !== nextProps.location.pathname) {
      return true;
    }

    const { user } = this.props;
    const nextUser = nextProps.user;
    if (user || nextUser) {
      if (user.first_name !== nextUser.first_name) {
        return true;
      }
      if (user.last_name !== nextUser.last_name) {
        return true;
      }
      if (user.email !== nextUser.last_name) {
        return true;
      }
    }
    return false;
  }

  render() {
    const { location, onClickHamburgerButton, loggedIn } = this.props;

    const showlogoutMenuRoute = ['/kyb', '/business-info'];
    const showlogoutMenu = showlogoutMenuRoute.includes(location.pathname);
    return (
      <nav
        className={`navbar mk-navbar ${styles['navbar-moka']}`}
        role="navigation"
      >
        <div className="container">
          <div
            className={`col-xs-3 col-md-1 col-image ${styles['logo-wrapper']}`}
          >
            <NavMokaLogo link={loggedIn ? this._mokaLogoLink() : '/login'} />
          </div>
          <div className="col-xs-6 nav-outlet visible-xs visible-sm ">
            {loggedIn && location.pathname !== '/settings/billing' && (
              <NavOutlet location={location} />
            )}
          </div>
          <div className="col-xs-3 visible-sm visible-xs">
            <button
              className="navbar-toggle navbar-toggle-always"
              data-toggle="collapse"
              data-target={
                loggedIn
                  ? showlogoutMenu
                    ? '#NavNotLoggedIn'
                    : '#NavLoggedIn'
                  : '#NavNotLoggedIn'
              }
              aria-controls="NavNotLoggedIn"
              aria-expanded="false"
              type="button"
              onClick={onClickHamburgerButton}
            >
              <span className="sr-only">Menu</span>
              <span className="icon-bar" />
              <span className="icon-bar" />
              <span className="icon-bar" />
            </button>
          </div>
          <div
            className={`col-xs-12 col-md-11 col-menu ${
              styles['navbar-wrapper']
            }`}
          >
            {location.pathname === '/business-info' ||
            location.pathname.startsWith('/kyb') ? (
              <NavNotLoggedIn location={location} />
            ) : loggedIn ? (
              <NavLoggedIn location={location} />
            ) : (
              <NavNotLoggedIn location={location} />
            )}
          </div>
        </div>
      </nav>
    );
  }

  _mokaLogoLink = () => {
    const { user } = this.props;
    if (user) {
      if (user.is_owner || user.is_manager) {
        return '/dashboard';
      }
      return '/settings/accounts';
    }
    return '/login';
  };
}

Nav.propTypes = {
  loggedIn: PropTypes.bool,
};

function mapDispatchToProps(dispatch) {
  return {
    onClickHamburgerButton: () => {
      dispatch(setTransactionDetail(null));
      dispatch(hideTransactionDetailModal());
      dispatch(setReceiptInvoices(null));
      dispatch(hideReceiptInvoice(true));
    },
  };
}

export default connect(
  null,
  mapDispatchToProps
)(Nav);
